/** @format */

import {
	AttributeOption,
	selectDisabledAttributes,
	selectSelectedAttributeValue
} from '@pdp/attributes/data-access';
import { Component, computed, inject, input, OnInit, output } from '@angular/core';

import { AttributeLabelComponent } from '../attribute-label/attribute-label.component';
import { CommonModule } from '@angular/common';
import { HmfSelectorComponent } from '@dsg-tech/homefield-angular';
import { Store } from '@ngrx/store';

@Component({
	selector: 'pdp-attributes-components-text-color-selection',
	styleUrls: ['./text-color-attribute.component.scss'],
	templateUrl: './text-color-attribute.component.html',
	imports: [CommonModule, AttributeLabelComponent, HmfSelectorComponent]
})
export class TextColorAttributeComponent implements OnInit {
	private readonly store = inject(Store);

	public readonly selectorAttributeData = input<AttributeOption[]>(undefined);
	public readonly labelAttrGroupName = input<string>(undefined);

	readonly selectedAttributeOnClick = output<AttributeOption>();

	selectDisabledAttributes$ = this.store.select(selectDisabledAttributes);

	private readonly selectAttributeAttrValue = computed(() =>
		this.store.selectSignal(selectSelectedAttributeValue(this.labelAttrGroupName()))()
	);

	ngOnInit() {
		// If the color black is available select it by default, otherwise select the first available color
		const colorBlack = this.selectorAttributeData().find(
			(attr) => attr.value.toLowerCase() === 'black'
		);

		if (colorBlack) {
			this.selectedAttribute(colorBlack);
		} else {
			this.selectedAttribute(this.selectorAttributeData()[0]);
		}
	}

	checkForIsSelected(attributesOption: AttributeOption): boolean {
		return (
			this.selectAttributeAttrValue()?.toLowerCase() === attributesOption.value.toLowerCase()
		);
	}

	/**
	 * @description Emits an event when a selector (i.e size, height etc.. non color attr) is clicked
	 * and updates the current selector to be selected.
	 **/
	selectedAttribute(selectedAttributeValue: AttributeOption) {
		this.selectedAttributeOnClick.emit(selectedAttributeValue);
	}

	trackByFn(index: number, item: AttributeOption): string {
		return index.toString() + item.name;
	}
}
